// Decodes the `role` claim out of a FRIDAY JWT without a round trip to the
// API. Mirrors the pattern already used in AiAssistantCard/ConnectorsCard/
// EconomicsTab (kept local there); shared here because Talent needs the same
// gate in two files. UI-only — the server is the actual enforcement point
// (see api/src/talent/router.ts redactCandidateEconomics), this is defence
// in depth so a non-owner never even sees a rate/salary input rendered.
export function decodeRole(token: string | null): string | null {
  if (!token) return null
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
    return typeof payload.role === 'string' ? payload.role : null
  } catch {
    return null
  }
}

const FRIDAY_TOKEN_KEY = 'friday_token'

/**
 * Owner check read straight from the persisted session token — no AuthProvider
 * needed, so it is safe in nav surfaces (sidebar, palette) and their tests.
 * UI gating only; the server remains the real enforcement point.
 */
export function isOwner(): boolean {
  if (typeof sessionStorage === 'undefined') return false
  return decodeRole(sessionStorage.getItem(FRIDAY_TOKEN_KEY)) === 'owner'
}
